import { BigNumber } from '@ethersproject/bignumber'

import { SupportedNetwork } from './networks'

export const MAX_UINT128 = BigNumber.from(2).pow(128).sub(1)

const IS_TESTNET = process.env.REACT_APP_CHAIN_ID === '8844'
export const HYDRA_URL = process.env.REACT_APP_HYDRA_URL
export const HYDRA_DOCS_URL = process.env.REACT_APP_HYDRA_DOCS_URL
export const HYDRA_TELEGRAM = process.env.REACT_APP_HYDRA_TELEGRAM

export const DEX_URL = IS_TESTNET ? process.env.REACT_APP_DEX_URL_TEST : process.env.REACT_APP_DEX_URL
export const EXPLORER_URL = IS_TESTNET ? process.env.REACT_APP_EXPLORER_URL_TEST : process.env.REACT_APP_EXPLORER_URL
export const TOKEN_ASSETS_URL = IS_TESTNET
  ? process.env.REACT_APP_TOKEN_ASSETS_URL_TEST
  : process.env.REACT_APP_TOKEN_ASSETS_URL

export const HEALTH_CLIENT_URL = IS_TESTNET
  ? process.env.REACT_APP_HEALTH_CLIENT_TEST
  : process.env.REACT_APP_HEALTH_CLIENT
export const V3_CLIENT_URL = IS_TESTNET ? process.env.REACT_APP_V3_CLIENT_TEST : process.env.REACT_APP_V3_CLIENT

const WETH_ADDRESS = IS_TESTNET ? process.env.REACT_APP_WETH_ADDRESS_TEST : process.env.REACT_APP_WETH_ADDRESS

export const WHYDRA_ADDRESSES = [WETH_ADDRESS]

export const TOKEN_HIDE: { [key: string]: string[] } = {
  [SupportedNetwork.ETHEREUM]: [],
}

export const POOL_HIDE: { [key: string]: string[] } = {
  [SupportedNetwork.ETHEREUM]: [],
}

export const NetworkContextName = 'NETWORK'
export const CHAIN_ID = Number(process.env.REACT_APP_CHAIN_ID) || 4488
